import { Link, useLocation } from 'react-router-dom';
import { ArrowLeft, ExternalLink, PackageX } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { derivePortalUrl } from './NoAccess';

/**
 * A page of a module the tenant has not booked (R-08, admin side). It used to
 * redirect silently to the dashboard, so nobody learned why the link "did
 * nothing". The address stays; the page says what is missing and who books it.
 */
export default function ModuleNotBooked() {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const portalUrl = typeof window !== 'undefined' ? derivePortalUrl(window.location) : null;

  return (
    <section className="space-y-6" aria-labelledby="module-not-booked-title" data-testid="module-not-booked">
      <div>
        <h1
          id="module-not-booked-title"
          className="flex items-center gap-3 text-2xl font-bold text-gray-900 dark:text-white"
        >
          <PackageX className="h-7 w-7 text-[#0077BE]" aria-hidden="true" />
          {t('errors.moduleNotBooked.title', 'Modul nicht gebucht')}
        </h1>
        <p className="mt-1 max-w-2xl text-sm text-gray-500 dark:text-gray-400">
          {t('errors.moduleNotBooked.description', 'Die Seite {{path}} gehört zu einem Modul, das für Ihren Mandanten nicht gebucht ist.', { path: pathname })}
        </p>
        <p className="mt-2 max-w-2xl text-sm text-gray-500 dark:text-gray-400">
          {t('errors.moduleNotBooked.nextStep', 'Module bucht der Plattform-Betrieb für Ihren Mandanten. Wenden Sie sich dafür an den Plattform-Support; danach öffnet sich die Seite hier.')}
        </p>
      </div>
      <div className="flex flex-wrap gap-3">
        <Link
          to="/dashboard"
          className="inline-flex items-center gap-2 rounded-lg bg-[#0077BE] px-4 py-2 text-sm font-medium text-white hover:bg-[#00629c]"
        >
          <ArrowLeft className="h-4 w-4" aria-hidden="true" />
          {t('errors.pageNotFound.backToDashboard', 'Zum Dashboard')}
        </Link>
        {portalUrl ? (
          <a
            href={portalUrl}
            className="inline-flex items-center gap-2 rounded-lg border border-[#0077BE] px-4 py-2 text-sm font-medium text-[#0077BE] hover:bg-[#0077BE]/10"
          >
            <ExternalLink className="h-4 w-4" aria-hidden="true" />
            {t('errors.noAccess.toPortal', 'Zum Portal')}
          </a>
        ) : null}
      </div>
    </section>
  );
}
